<template>
  <f7-page no-swipeback ref="page">
    <f7-navbar title="商品詳細 Product Detail" back-link="返回 Back"></f7-navbar>

    <f7-block v-if="loading">
      Loading...
    </f7-block>
    <div v-else>
      <div class="px-4 space-y-1">
        <h1 class="text-lg">
          {{ product.name }}
        </h1>
        <div class="text-sm">
          單價: ${{ Math.round((product.price / 100) * 10) / 10 }}
        </div>
        <div class="text-sm">
          總庫存: {{ product.inventory_quantity }}
        </div>
        <div class="text-sm">
          過期庫存: {{ product.expired_inventory_quantity }}
        </div>
      </div>

      <div class="mt-4">
        <div class="bg-gray-200 py-2 px-4">
          <div class="text-sm font-semibold">更新庫存 Update Inventory</div>
        </div>

        <div class="flex p-4">
          <div class="w-3/5 mr-4">
            <div class="text-gray-700 text-xs whitespace-nowrap mb-1">
              到期日 Expiry Date
            </div>
            <div v-if="!hideDateInput" class="bg-gray-200 p-2">
              <DateTimePicker class="h-4" v-model="form.expired_date" />
            </div>
          </div>
          <div class="w-2/5">
            <div class="text-gray-700 text-xs whitespace-nowrap mb-2">
              數量 Qty
            </div>

            <div class="flex">
              <button class="bg-gray-300 text-gray-500 border-none" @click="form.quantity = form.quantity - 1">-</button>
              <div class="bg-gray-200 p-2">
                <input v-model="form.quantity" type="number" class="w-full text-center" />
              </div>
              <button class="bg-gray-300 text-gray-500 border-none" @click="form.quantity++">+</button>
            </div>
          </div>
        </div>

        <div class="flex space-x-2 px-4">
          <f7-button fill class="w-1/2" color="red" @click="decrement">減少 Decrement</f7-button>
          <f7-button fill class="w-1/2" @click="increment">增加 Increment</f7-button>
        </div>
      </div>

      <div class="mt-4">
        <div class="bg-gray-200 py-2 px-4">
          <div class="text-sm font-semibold">庫存 Inventory</div>
        </div>

        <ul class="list-none px-4">
          <li v-for="inventory in product.inventories" :key="inventory.id" class="py-1">
            <div
              class="flex flex-row justify-between items-center bg-gray-50 py-2 px-3 rounded shadow-sm"
              @click="setFormDate(inventory.expired_date)"
            >
              <div>
                <div>{{ inventory.expired_date }}</div>
                <span
                  class="text-xs rounded-lg px-2 py-0.5"
                  :class="{
                    'bg-green-500 text-green-100': inventory.status === 'available',
                    'bg-gray-200 text-gray-500': inventory.status === 'expired',
                  }"
                >
                  {{ inventory.status }}
                </span>
              </div>
              <div class="text-base font-semibold text-gray-700">{{ inventory.quantity }}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </f7-page>
</template>

<script>
import axios from 'axios'

import DateTimePicker from '../DateTimePicker'

export default {
  components: {
    DateTimePicker,
  },

  props: {
    productId: String,
  },

  data: () => ({
    product: null,
    loading: true,
    form: {
      quantity: 0,
      expired_date: null,
    },
    hideDateInput: false,
  }),

  mounted() {
    this.fetch()
  },

  methods: {
    fetch() {
      this.loading = true

      axios.get('/api/products/' + this.productId)
        .then(({ data }) => {
          this.product = data
          this.loading = false
        })
    },

    decrement() {
      this.$f7.dialog.preloader('提交中 Submitting');

      axios.delete(`/api/products/${this.product.id}/inventory`, { params: this.form })
        .then(() => {
          this.$f7.dialog.close()
          this.fetch()
        })
        .catch((error) => {
          this.$f7.dialog.close()
          this.$f7.dialog.alert(error.response.data.message)
        })
    },
    increment() {
      this.$f7.dialog.preloader('提交中 Submitting');

      axios.post(`/api/products/${this.product.id}/inventory`, this.form)
        .then(() => {
          this.$f7.dialog.close()
          this.fetch()
        })
        .catch((error) => {
          this.$f7.dialog.close()
          this.$f7.dialog.alert(error.response.data.message)
        })
    },

    setFormDate(date) {
      this.hideDateInput = true
      this.form.expired_date = date
      setTimeout(() => (this.hideDateInput = false), 300)
    },
  },
}
</script>
